import { render, staticRenderFns } from "./cabinet-requests-item-header.vue?vue&type=template&id=5460b90a&scoped=true&"
import script from "./cabinet-requests-item-header.vue?vue&type=script&lang=js&"
export * from "./cabinet-requests-item-header.vue?vue&type=script&lang=js&"
import style0 from "./cabinet-requests-item-header.vue?vue&type=style&index=0&id=5460b90a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5460b90a",
  null
  
)

export default component.exports